import React from "react";
import {
  Paper,
  Grid,
  Box,
  Typography,
  IconButton
} from "@material-ui/core";
import { Droppable, Draggable } from "react-beautiful-dnd";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import './LizAccounting.css'

function InvestorPanel({
                         investor,
                         profitShares,
                         additions,
                         subtractions,
                         openManualDialog,
                         onRemoveManual
                       }) {

  const formatAmount = (amount) =>
      Number(amount || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

  const profitTotal = profitShares.reduce((a, b) => a + Number(b.amount || 0), 0);
  const additionsSum = additions.reduce((sum, a) => sum + Number(a.amount || 0), 0);
  const subtractionsSum = subtractions.reduce((sum, s) => sum + Number(s.amount || 0), 0);

  const additionsTotal = profitTotal + additionsSum;
  const subtractionsTotal = additionsTotal - subtractionsSum;

  return (
      <Grid item xs={12} md={6}>
        <Paper className="investorPanel">

          {/* Header */}
          <Typography className="investor-title">
            {investor}
          </Typography>

          {/* PROFIT */}
          <Box className="section-box profit-box">
            <Typography className="section-title">Profit Share</Typography>

            {profitShares.map((p, i) => (
                <Box key={i} className="row-line">
                  <Typography>{p.location}</Typography>
                  <Typography>${formatAmount(p.amount)}</Typography>
                </Box>
            ))}

            <Box className="row-total">
              <Typography style={{fontWeight:'bold'}}>Total</Typography>
              <Typography style={{fontWeight:'bold'}}>${formatAmount(profitTotal)}</Typography>
            </Box>
          </Box>

          {/* ADDITIONS */}
          <Droppable droppableId={`${investor}-additions`}>
            {(provided) => (
                <Box
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="section-box add-box"
                >
                  <Box className="section-header">
                    <Typography className="section-title">Additions</Typography>
                    <IconButton onClick={() => openManualDialog("ADD", investor)}>
                      <AddCircleIcon color="secondary" />
                    </IconButton>
                  </Box>

                  {additions.map((item, index) => (
                      <Draggable
                          key={`add-${investor}-${index}`}
                          draggableId={`add-${investor}-${index}`}
                          index={index}
                      >
                        {(dragProvided) => (
                            <Box
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                {...dragProvided.dragHandleProps}
                                className="drag-item"
                                style={dragProvided.draggableProps.style}
                            >
                              <Typography className="drag-text">
                                {item.description}
                                {item.locationName && ` (${item.locationName})`}
                              </Typography>

                              <div className="amount-actions">
                                <Typography>
                                  ${formatAmount(item.amount)}
                                </Typography>

                                {item.isManual && (
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            onRemoveManual(investor, "ADD", index)
                                        }
                                    >
                                      <RemoveCircleIcon color="error" />
                                    </IconButton>
                                )}
                              </div>
                            </Box>
                        )}
                      </Draggable>
                  ))}

                  {provided.placeholder}

                  <Box className="row-total" >
                    <Typography style={{fontWeight:'bold'}}>Subtotal</Typography>
                    <Typography style={{fontWeight:'bold'}}>${formatAmount(additionsTotal)}</Typography>
                  </Box>
                </Box>
            )}
          </Droppable>

          {/* SUBTRACTIONS */}
          <Droppable droppableId={`${investor}-subtractions`}>
            {(provided) => (
                <Box
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="section-box sub-box"
                >
                  <Box className="section-header">
                    <Typography className="section-title">Subtractions</Typography>
                    <IconButton onClick={() => openManualDialog("SUB", investor)}>
                      <AddCircleIcon color="secondary" />
                    </IconButton>
                  </Box>

                  {subtractions.map((item, index) => (
                      <Draggable
                          key={`sub-${investor}-${index}`}
                          draggableId={`sub-${investor}-${index}`}
                          index={index}
                      >
                        {(dragProvided) => (
                            <Box
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                {...dragProvided.dragHandleProps}
                                className="drag-item"
                                style={dragProvided.draggableProps.style}
                            >
                              <Typography className="drag-text">
                                {item.description}
                                {item.locationName && ` (${item.locationName})`}
                              </Typography>

                              <div className="amount-actions">
                                <Typography>
                                  ${formatAmount(item.amount)}
                                </Typography>

                                {item.isManual && (
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            onRemoveManual(investor, "SUB", index)
                                        }
                                    >
                                      <RemoveCircleIcon color="error" />
                                    </IconButton>
                                )}
                              </div>
                            </Box>
                        )}
                      </Draggable>
                  ))}

                  {provided.placeholder}

                  <Box className="row-total">
                    <Typography style={{fontWeight:'bold'}}>Subtotal</Typography>
                    <Typography style={{fontWeight:'bold'}}>${formatAmount(subtractionsTotal)}</Typography>
                  </Box>
                </Box>
            )}
          </Droppable>

        </Paper>
      </Grid>
  );
}

export default InvestorPanel;
